export default __webpack_public_path__ + "static/media/FinanceRealCase-mobile-en.d17d4408.jpg";